module.exports = __webpack_public_path__ + "static/media/24in7.4c427d74.jpg";